/* eslint-disable */

/** unique or primary key constraints on table "argo.auth_refresh_token" */
export enum ArgoAuthRefreshTokenConstraint {
  /** unique or primary key constraint on columns "auth_refresh_token_id" */
  AuthRefreshTokenPkey = 'auth_refresh_token_pkey',
  /** unique or primary key constraint on columns "refresh_token" */
  AuthRefreshTokenRefreshTokenKey = 'auth_refresh_token_refresh_token_key'
}

/** select columns of table "argo.auth_refresh_token" */
export enum ArgoAuthRefreshTokenSelectColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "argo.auth_refresh_token" */
export enum ArgoAuthRefreshTokenUpdateColumn {
  /** column name */
  AuthProviderRecordId = 'auth_provider_record_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiresAt = 'expires_at',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  RefreshToken = 'refresh_token',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

